import Lenis from 'lenis';

import { ScrollBus } from './scroll-bus';
import { checkScrollTop } from './scroll-head';

const lenis = new Lenis({
  duration: 1.2,
  smooth: true,
  smoothTouch: false,
  syncTouch: false,
  infinite: false,
});

lenis.on('scroll', ({ scroll }) => {
  ScrollBus.emit(scroll);
  checkScrollTop(scroll);
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

export function disableScrollLenis() {
  lenis.stop();
}
export function enableScrollLenis() {
  lenis.start();
}

export { lenis };
